import ImagePerjalananBisnis from "../../images/Perjalanan-Bisnis.avif";
import ImageAcaraPernikahan from "../../images/Acara-Pernikahan.avif";
import ImageAntarJemputBandara from "../../images/Antar-Jemput-Bandara.avif";
import ImageLiburanBersama from "../../images/Liburan-Bersama.avif";
import FeatureImage from "../../components/FeatureImage";

const features = [
  {
    src: ImagePerjalananBisnis,
    alt: "Perjalanan Bisnis",
    title: "Perjalanan Bisnis",
    description:
      "Ciptakan kesan personal pertama yang tak terlupakan dengan Alphard.",
  },
  {
    src: ImageAcaraPernikahan,
    alt: "Acara Pernikahan",
    title: "Acara Pernikahan",
    description:
      "Rasakan kemewahan dan kenyamanan di hari spesial Anda bersama Alphard.",
  },
  {
    src: ImageAntarJemputBandara,
    alt: "Antar Jemput Bandara",
    title: "Antar Jemput Bandara",
    description:
      "Ubah perjalanan Anda menjadi lebih nyaman dan efisien dengan Alphard.",
  },
  {
    src: ImageLiburanBersama,
    alt: "Liburan Bersama",
    title: "Liburan Bersama",
    description:
      "Ciptakan kesan personal pertama yang tak terlupakan dengan Alphard.",
  },
];

export default function Functionality() {
  return (
    <section className="w-full min-h-screen flex flex-col items-center justify-center text-center p-10 md:p-20">
      <h2 className="text-3xl poppins-semibold text-slate-700 text-left md:text-center">
        Lengkapi Berbagai Kegiatan Anda <br />
        Menggunakan Toyota Alphard
      </h2>
      <p className="text-slate-600 mt-2 text-left md:text-center">
        Apapun keperluan Anda, dengan moda transportasi yang nyaman dan berkelas
        memberikan kesan yang menakjubkan
      </p>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mt-10">
        {features.map((feature, index) => (
          <FeatureImage
            key={index}
            src={feature.src}
            alt={feature.alt}
            title={feature.title}
            description={feature.description}
          />
        ))}
      </div>
    </section>
  );
}
